function r(t, n) {
  const o = t < 0 ? "-" : "", a = Math.abs(t).toString().padStart(n, "0");
  return o + a;
}
export {
  r as addLeadingZeros
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/date-fns@3.6.0/~/date-fns/_lib/addLeadingZeros.js
// module id = 878
// module chunks = 67